'use strict';

(function ($) {
    $.widget('ui.agSelectionBoxes', {
        _create: function () {
            var $element = $(this.element);
            if (!$element.hasClass('form-control-selection-boxes')) {
                $element.addClass('form-control-selection-boxes');
            }

            var $targetHidden = $(this.element).find('select.selection-boxes-target-hidden');
            $targetHidden.find('option').prop('selected', true);

            this._on(this.element, {
                'change input.selection-boxes-source': function (event) {
                    var disabled = $(event.target).val() == null || $(event.target).val().length == 0;
                    $(this.element).find('input.selection-boxes-add').prop('disabled', disabled);
                }
            });
            this._on(this.element, {
                'change input.selection-boxes-target': function (event) {
                    var disabled = $(event.target).val() == null || $(event.target).val().length == 0;
                    $(this.element).find('input.selection-boxes-remove').prop('disabled', disabled);
                }
            });
            this._on(this.element, {
                'click input.selection-boxes-add': function (event) {
                    var $source = $(this.element).find('select.selection-boxes-source');
                    var $target = $(this.element).find('select.selection-boxes-target');
                    var $targetHidden = $(this.element).find('select.selection-boxes-target-hidden');
                    var $selected = $source.find('option:selected');
                    $target.append($selected).change();
                    $source.change();
                    // TODO optimize
                    $($target).sortOptions();
                    $targetHidden.empty().append($target.find('option').clone(false).prop('selected', true));
                }
            });
            this._on(this.element, {
                'click input.selection-boxes-remove': function (event) {
                    var $source = $(this.element).find('select.selection-boxes-source');
                    var $target = $(this.element).find('select.selection-boxes-target');
                    var $targetHidden = $(this.element).find('select.selection-boxes-target-hidden');
                    var $selected = $target.find('option:selected');
                    $source.append($selected).change();
                    $target.change();
                    // TODO optimize
                    $($source).sortOptions();
                    $targetHidden.empty().append($target.find('option').clone(false).prop('selected', true));
                }
            });
            this._on(this.element, {
                'dblclick .selection-boxes-source': function (event) {
                    var $source = $(this.element).find('select.selection-boxes-source');
                    var $target = $(this.element).find('select.selection-boxes-target');
                    var $targetHidden = $(this.element).find('select.selection-boxes-target-hidden');
                    var $selected = $source.find('option:selected');
                    $target.append($selected).change();
                    $source.change();
                    // TODO optimize
                    $($target).sortOptions();
                    $targetHidden.empty().append($target.find('option').clone(false).prop('selected', true));
                }
            });
            this._on(this.element, {
                'dblclick .selection-boxes-target': function (event) {
                    var $source = $(this.element).find('select.selection-boxes-source');
                    var $target = $(this.element).find('select.selection-boxes-target');
                    var $targetHidden = $(this.element).find('select.selection-boxes-target-hidden');
                    var $selected = $target.find('option:selected');
                    $source.append($selected).change();
                    $target.change();
                    // TODO optimize
                    $($source).sortOptions();
                    $targetHidden.empty().append($target.find('option').clone(false).prop('selected', true));
                }
            });

            $.fn.sortOptions = function () {
                $(this).each(function () {
                    var op = $(this).children("option");
                    op.sort(function (a, b) {
                        return a.text.toUpperCase() > b.text.toUpperCase() ? 1 : -1;
                    })
                    return $(this).empty().append(op);
                });
            }


        }
    });
})($);